import React, { useCallback } from 'react'
import { useUpdatePassword } from 'api'
import { Link } from 'components'
import { WbControlError } from '@workbench/react/dist'
import { PasswordResetUpdateForm } from './PasswordResetUpdateForm'
import { LoginWrapper } from '../LoginWrapper'
import classes from './PasswordResetPage.module.scss'
import { useTranslation } from 'react-i18next'

interface PasswordResetUpdatePageProps {
  userId: string
  token: string
}

export const PasswordResetUpdatePage: React.FunctionComponent<PasswordResetUpdatePageProps> = ({
  userId,
  token,
}) => {
  const { t } = useTranslation()
  const [mutate, { status, error, reset }] = useUpdatePassword()
  const onSubmit = useCallback(
    (values, { setSubmitting }) => {
      reset()
      mutate({
        userId,
        params: {
          token,
          password: values.password,
          confirmPassword: values.confirmPassword,
        },
      })
      setSubmitting(false)
    },
    [mutate, reset, token, userId]
  )

  return (
    <LoginWrapper
      title={t('pages.login.passwordResetPage.passwordResetUpdatePage.title')}
    >
      {status === 'success' ? (
        <p>
          {t(
            'pages.login.passwordResetPage.passwordResetUpdatePage.status.success'
          )}
        </p>
      ) : (
        <div className={classes.form}>
          {error && (
            <div className={classes.error}>
              <WbControlError>
                {error.status === 403 && (
                  <>
                    {t(
                      'pages.login.passwordResetPage.passwordResetUpdatePage.status.error403'
                    )}
                  </>
                )}
                {error.status === 422 && (
                  <>
                    {t(
                      'pages.login.passwordResetPage.passwordResetUpdatePage.status.error422'
                    )}
                  </>
                )}
                {error.status !== 403 && error.status !== 422 && (
                  <>
                    {t(
                      'pages.login.passwordResetPage.passwordResetUpdatePage.status.error'
                    )}
                  </>
                )}
              </WbControlError>
            </div>
          )}

          <PasswordResetUpdateForm onSubmit={onSubmit} />
        </div>
      )}

      <Link to="/login">{t('global.returnToLogin')}</Link>
    </LoginWrapper>
  )
}
